import validate from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/var/www/html/collection-experience/frontend-2/middleware/router.global.js";
import manifest_45route_45rule from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}